var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "broadcast-requests-wa-business" } }, [
    _c(
      "div",
      { staticClass: "d-flex", staticStyle: { "background-color": "#ffffff" } },
      [
        _c("div", { staticClass: "main-content" }, [
          _vm.formVisible
            ? _c(
                "div",
                [
                  _c("NewBroadcastMessage", {
                    attrs: {
                      "on-success": _vm.addItem,
                      "on-cancel": function () {
                        return (_vm.formVisible = false)
                      },
                      channel: _vm.channel,
                    },
                  }),
                ],
                1
              )
            : _c(
                "div",
                [
                  _c(
                    "div",
                    { staticClass: "toolbar" },
                    [
                      _c("div", { staticClass: "segmented-btn-container" }, [
                        _c(
                          "div",
                          {
                            staticClass: "btn",
                            class: { active: !_vm.archiveMode },
                            on: {
                              click: function ($event) {
                                _vm.archiveMode = false
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "container" }, [
                              _c("span", { staticClass: "label" }, [
                                _vm._v(" " + _vm._s(_vm.$t("wp.active")) + " "),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "badge" }, [
                                _c("div", { staticClass: "badge-container" }, [
                                  _vm._v(_vm._s(_vm.stats.active)),
                                ]),
                              ]),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "btn",
                            class: { active: _vm.archiveMode },
                            on: {
                              click: function ($event) {
                                _vm.archiveMode = true
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "container" }, [
                              _c("div", { staticClass: "label" }, [
                                _c(
                                  "span",
                                  { staticClass: "material-icons mr-1" },
                                  [_vm._v(" archive ")]
                                ),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("wp.archived"))),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "badge" }, [
                                _c("div", { staticClass: "badge-container" }, [
                                  _vm._v(_vm._s(_vm.stats.archived)),
                                ]),
                              ]),
                            ]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.createBroadcastMessage },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("wp.createBroadcastMessage")) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "w-100 d-flex justify-content-end mt-3",
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "m-5" },
                    [
                      _c("a-table", {
                        key: "vtable-" + _vm.renderCount,
                        attrs: {
                          locale: { emptyText: _vm.$t("message.noData") },
                          rowKey: "_id",
                          columns: _vm.cols,
                          dataSource: _vm.items,
                          pagination: false,
                          customRow: function (record) {
                            return {
                              props: {},
                              on: {
                                mouseover: function (event) {
                                  _vm.rowMouseOver(record)
                                },
                                mouseleave: function (event) {
                                  _vm.rowMouseLeave(record)
                                }, // mouse leave row
                                click: function () {
                                  _vm.showDetailRecord(record)
                                },
                              },
                            }
                          },
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "avatar",
                            fn: function (text, record) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "user-segment-avatar text-center",
                                    class: {
                                      "user-segment-avatar-odd":
                                        _vm.isRowNumberOdd(record),
                                    },
                                  },
                                  [
                                    _c(
                                      "md-highlight-text",
                                      {
                                        staticClass: "text-center",
                                        attrs: { "md-term": "term" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              (record.title || "")
                                                .slice(0, 2)
                                                .toUpperCase()
                                            ) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "description",
                            fn: function (text, record) {
                              return _c("span", {}, [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "tippy",
                                        rawName: "v-tippy",
                                        value: {
                                          followCursor: true,
                                          placement: "bottom-end",
                                        },
                                        expression:
                                          "{ followCursor: true, placement: 'bottom-end' }",
                                      },
                                    ],
                                    staticClass: "text-truncate",
                                    attrs: { content: record.description },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        record.description.slice(0, 15) + "..."
                                      )
                                    ),
                                  ]
                                ),
                              ])
                            },
                          },
                          {
                            key: "numbers",
                            fn: function (text, record) {
                              return _c("span", {}, [
                                _vm._v(
                                  _vm._s(
                                    !!record.all
                                      ? _vm.$_.get(_vm.contacts, "length") +
                                          " " +
                                          _vm.$t("wp.numbers")
                                      : _vm.$_.get(
                                          record,
                                          "customPhoneNumbers.length"
                                        )
                                      ? _vm.$_.get(
                                          record,
                                          "customPhoneNumbers.length"
                                        ) +
                                        " " +
                                        _vm.$t("wp.numbers")
                                      : "" + _vm.$t("wp.noNumbersAdded")
                                  )
                                ),
                              ])
                            },
                          },
                          {
                            key: "messages",
                            fn: function (text, record) {
                              return _c("span", {}, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$_.get(record, "messages.length") > 1
                                      ? _vm.$_.get(record, "messages.length") +
                                          " " +
                                          _vm.$t("wp.messages")
                                      : _vm.$_.get(record, "messages.length") +
                                          " " +
                                          _vm.$t("wp.message")
                                  )
                                ),
                              ])
                            },
                          },
                          {
                            key: "successMessageRatio",
                            fn: function (text, record) {
                              return _c(
                                "span",
                                {},
                                [
                                  _vm.getTotalMessageSent(record) > 0
                                    ? _c(
                                        "b-progress",
                                        {
                                          directives: [
                                            {
                                              name: "tippy",
                                              rawName: "v-tippy",
                                              value: {
                                                followCursor: true,
                                                placement: "bottom-end",
                                              },
                                              expression:
                                                "{ followCursor: true, placement: 'bottom-end' }",
                                            },
                                          ],
                                          attrs: {
                                            max: 100,
                                            "show-value": "",
                                            content:
                                              _vm.getSuccessRatioTooltipText(
                                                record
                                              ),
                                          },
                                        },
                                        [
                                          _c(
                                            "b-progress-bar",
                                            {
                                              attrs: {
                                                value:
                                                  _vm.getSuccessMessageRatio(
                                                    record
                                                  ),
                                                variant: "success",
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.getSuccessMessageRatio(
                                                        record
                                                      ) + "%"
                                                    ) +
                                                    "\n                                    "
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-progress-bar",
                                            {
                                              attrs: {
                                                value:
                                                  100 -
                                                  _vm.getSuccessMessageRatio(
                                                    record
                                                  ),
                                                variant: "danger",
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      100 -
                                                        _vm.getSuccessMessageRatio(
                                                          record
                                                        ) +
                                                        "%"
                                                    ) +
                                                    "\n                                    "
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "b-progress",
                                        {
                                          attrs: { max: 100, "show-value": "" },
                                        },
                                        [
                                          _c("b-progress-bar", {
                                            attrs: {
                                              value: 0,
                                              variant: "success",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                ],
                                1
                              )
                            },
                          },
                          {
                            key: "usageCost",
                            fn: function (text, record) {
                              return _c("span", {}, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.getUsageCost(record) + " ₺") +
                                    "\n                        "
                                ),
                              ])
                            },
                          },
                          {
                            key: "createdAt",
                            fn: function (text, record) {
                              return _c("span", {}, [
                                _vm._v(_vm._s(_vm.createdAtHumanize(record))),
                              ])
                            },
                          },
                          {
                            key: "progress",
                            fn: function (text, record) {
                              return _c(
                                "span",
                                {},
                                [
                                  record.status === "created"
                                    ? _c("a-progress", {
                                        directives: [
                                          {
                                            name: "tippy",
                                            rawName: "v-tippy",
                                            value: {
                                              followCursor: true,
                                              placement: "bottom-end",
                                            },
                                            expression:
                                              "{ followCursor: true, placement: 'bottom-end' }",
                                          },
                                        ],
                                        attrs: {
                                          percent: _vm.getPercent(record),
                                          size: "small",
                                          status: "normal",
                                          content: _vm.getProgressText(record),
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  record.status === "scheduled"
                                    ? _c("a-progress", {
                                        directives: [
                                          {
                                            name: "tippy",
                                            rawName: "v-tippy",
                                            value: {
                                              followCursor: true,
                                              placement: "bottom-end",
                                            },
                                            expression:
                                              "{ followCursor: true, placement: 'bottom-end' }",
                                          },
                                        ],
                                        attrs: {
                                          percent: _vm.getPercent(record),
                                          size: "small",
                                          status: "normal",
                                          content: _vm.getProgressText(record),
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  record.status === "queued"
                                    ? _c("a-progress", {
                                        directives: [
                                          {
                                            name: "tippy",
                                            rawName: "v-tippy",
                                            value: {
                                              followCursor: true,
                                              placement: "bottom-end",
                                            },
                                            expression:
                                              "{ followCursor: true, placement: 'bottom-end' }",
                                          },
                                        ],
                                        attrs: {
                                          percent: _vm.getPercent(record),
                                          size: "small",
                                          status: "normal",
                                          content: _vm.getProgressText(record),
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  record.status === "running"
                                    ? _c("a-progress", {
                                        directives: [
                                          {
                                            name: "tippy",
                                            rawName: "v-tippy",
                                            value: {
                                              followCursor: true,
                                              placement: "bottom-end",
                                            },
                                            expression:
                                              "{ followCursor: true, placement: 'bottom-end' }",
                                          },
                                        ],
                                        attrs: {
                                          percent: _vm.getPercent(record),
                                          size: "small",
                                          status: "active",
                                          content: _vm.getProgressText(record),
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  record.status === "completed"
                                    ? _c("a-progress", {
                                        directives: [
                                          {
                                            name: "tippy",
                                            rawName: "v-tippy",
                                            value: {
                                              followCursor: true,
                                              placement: "bottom-end",
                                            },
                                            expression:
                                              "{ followCursor: true, placement: 'bottom-end' }",
                                          },
                                        ],
                                        attrs: {
                                          percent: _vm.getPercent(record),
                                          size: "small",
                                          status: "success",
                                          content: _vm.getProgressText(record),
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  record.status === "failed"
                                    ? _c("a-progress", {
                                        directives: [
                                          {
                                            name: "tippy",
                                            rawName: "v-tippy",
                                            value: {
                                              followCursor: true,
                                              placement: "bottom-end",
                                            },
                                            expression:
                                              "{ followCursor: true, placement: 'bottom-end' }",
                                          },
                                        ],
                                        attrs: {
                                          percent: _vm.getPercent(record),
                                          size: "small",
                                          status: "exception",
                                          content: _vm.getProgressText(record),
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  record.status === "cancelled"
                                    ? _c("a-progress", {
                                        directives: [
                                          {
                                            name: "tippy",
                                            rawName: "v-tippy",
                                            value: {
                                              followCursor: true,
                                              placement: "bottom-end",
                                            },
                                            expression:
                                              "{ followCursor: true, placement: 'bottom-end' }",
                                          },
                                        ],
                                        attrs: {
                                          percent: _vm.getPercent(record),
                                          size: "small",
                                          status: "exception",
                                          content: _vm.getProgressText(record),
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            },
                          },
                          {
                            key: "status",
                            fn: function (text, record) {
                              return _c(
                                "span",
                                {},
                                [
                                  record.status === "created"
                                    ? _c("a-badge", {
                                        attrs: {
                                          color: "cyan",
                                          text: _vm.$t("wp.created"),
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  record.status === "scheduled"
                                    ? _c("a-badge", {
                                        attrs: {
                                          color: "volcano",
                                          text: _vm.$t("wp.scheduled"),
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  record.status === "queued"
                                    ? _c("a-badge", {
                                        attrs: {
                                          color: "gray",
                                          text: _vm.$t("wp.queued"),
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  record.status === "running"
                                    ? _c("a-badge", {
                                        attrs: {
                                          color: "blue",
                                          text: _vm.$t("wp.running"),
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  record.status === "completed"
                                    ? _c("a-badge", {
                                        attrs: {
                                          color: "green",
                                          text: _vm.$t("wp.completed"),
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  record.status === "failed"
                                    ? _c("a-badge", {
                                        directives: [
                                          {
                                            name: "tippy",
                                            rawName: "v-tippy",
                                            value: {
                                              followCursor: true,
                                              placement: "bottom-end",
                                            },
                                            expression:
                                              "{ followCursor: true, placement: 'bottom-end' }",
                                          },
                                        ],
                                        attrs: {
                                          color: "red",
                                          text: _vm.$t("wp.failed"),
                                          content: _vm.getReasonMessage(record),
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  record.status === "cancelled"
                                    ? _c("a-badge", {
                                        attrs: {
                                          color: "yellow",
                                          text: _vm.$t("wp.cancelled"),
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            },
                          },
                          {
                            key: "operation",
                            fn: function (text, record) {
                              return _c(
                                "span",
                                {
                                  staticClass:
                                    "d-flex flex-row justify-content-center operation-buttons",
                                },
                                [
                                  !_vm.archiveMode &&
                                  !["queued", "running", "created"].includes(
                                    record.status
                                  )
                                    ? _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.archiveMode === false,
                                              expression:
                                                "archiveMode === false",
                                            },
                                          ],
                                          staticClass:
                                            "material-icons mx-2 text-primary operation-button",
                                          on: {
                                            click: function () {
                                              return _vm.markAsArchived(record)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                archive\n                            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "material-icons mx-2 text-secondary operation-button",
                                      on: {
                                        click: function ($event) {
                                          return _vm.showDetailRecord(record)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                document_scanner\n                            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  ![
                                    "completed",
                                    "failed",
                                    "cancelled",
                                  ].includes(record.status)
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "material-icons mx-2 text-danger operation-button",
                                          on: {
                                            click: function () {
                                              return _vm.cancelBroadcast(record)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                cancel\n                            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              )
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.selectedRowRecord
                    ? _c(
                        "a-modal",
                        {
                          staticClass: "details",
                          attrs: {
                            centered: "",
                            visible: !!_vm.selectedRowRecord,
                            footer: null,
                            closable: true,
                            width: "1080px",
                          },
                          on: {
                            cancel: function ($event) {
                              _vm.selectedRowRecord = null
                            },
                          },
                        },
                        [
                          _c("BroadcastRequestViewer", {
                            attrs: { request: _vm.selectedRowRecord },
                            on: {
                              newBroadcastCreated: _vm.newBroadcastCreated,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }